import { ChevronDownIcon, ChevronUpIcon } from '@fukuri-admins/ui/common';
import { TableCell } from '@mui/material';
import clsx from 'clsx';
import { ActionTableColumnsType } from '../../../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../../../types/table/ActionTableSortParamsType';
import styles from './styles.module.scss';

interface Props {
  columns: ActionTableColumnsType[];
  onClickHeader: (key: string) => void;
  sortParams: ActionTableSortParamsType;
  onClickHeaderCheckbox?: () => void;
  selectAllState?: true | false | 'indeterminate';
}

const TableColumns = ({
  columns,
  onClickHeader,
  sortParams,
  onClickHeaderCheckbox,
  selectAllState,
}: Props) => {
  return (
    <>
      {columns?.map((column: ActionTableColumnsType, key: number) => {
        const isActiveSort = sortParams.column === column.key;
        const isSortable = column.sortable;

        return (
          <TableCell
            key={key}
            onClick={() => {
              if (isSortable) {
                onClickHeader(column.key);
              } else if (column.key === 'checkbox') {
                onClickHeaderCheckbox();
              }
            }}
            className={clsx(styles.tableHeaderCell)}
            data-testid='table-header'
          >
            <div
              className={clsx(styles.tableHeaderCellDiv, {
                [styles.justifyContentCenter]: column.key === 'checkbox',
              })}
            >
              {column.key === 'checkbox' ? (
                <input
                  type='checkbox'
                  checked={selectAllState === true}
                  aria-label='全ユーザーを選択'
                  readOnly
                />
              ) : (
                <>
                  {column.label}
                  {isSortable &&
                    (isActiveSort ? (
                      sortParams.isAsc ? (
                        <ChevronUpIcon className={styles.sortIconActive} />
                      ) : (
                        <ChevronDownIcon className={styles.sortIconActive} />
                      )
                    ) : (
                      <ChevronDownIcon className={styles.sortIconInactive} />
                    ))}
                </>
              )}
            </div>
          </TableCell>
        );
      })}
    </>
  );
};

export default TableColumns;
